import georgePic from "@/public/images/artists/george.jpg";
import { Artist } from "@/types/types";

export const george = {
  id: "109",
  name: "George",
  image: georgePic,
  description: `George's voice is a versatile gem, capable of embracing a wide array of musical styles, from tender ballads to energetic anthems. But what truly sets him apart is the unique character infused into his sound. With meticulous processing, his voice echoes the charm of old sound recordings, evoking a sense of nostalgia and timeless elegance.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fgeorge-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Pop", "Soul"],
      secondary: ["Singer", "1970s", "Classic"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 52,
        high: 70,
      },
    },
  },
} as const satisfies Artist;
